import React from 'react';
import cx from 'classnames';

import styles from './emptyCart.module.less';

export const EmptyCart = ({ className }: { className?: string }) => {
  return (
    <div className={cx(styles.emptyCart, className)}>
      <p>You have nothing in your cart.</p>
      <p>Get shopping!</p>
    </div>
  );
};
